<div class="tpl3pl-page-container tpl3pl-shipments">

	<!-- ── Stat bar ─────────────────────────────────────────────────────── -->
	<div class="sh-stats-wrap">
		<div class="sh-stats-loading" *ngIf="statsLoading && !stats">
			<mat-spinner diameter="24"></mat-spinner>
			<span>Loading…</span>
		</div>
		<div class="sh-stats" *ngIf="stats as s">
			<div class="sh-stat sh-stat--accent">
				<span class="sh-stat-val">{{ s.actionable }}</span>
				<span class="sh-stat-lbl">Actionable</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.pending }}</span>
				<span class="sh-stat-lbl">Pending</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.approved }}</span>
				<span class="sh-stat-lbl">Approved</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.invoicing }}</span>
				<span class="sh-stat-lbl">Invoicing</span>
			</div>
			<div class="sh-stat sh-stat--ok">
				<span class="sh-stat-val">{{ s.invoiced }}</span>
				<span class="sh-stat-lbl">Invoiced</span>
			</div>
			<div class="sh-stat sh-stat--warn">
				<span class="sh-stat-val">{{ s.failed }}</span>
				<span class="sh-stat-lbl">Failed</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.on_hold }}</span>
				<span class="sh-stat-lbl">On hold</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.rejected }}</span>
				<span class="sh-stat-lbl">Rejected</span>
			</div>
		</div>
	</div>

	<!-- ── Filter bar ───────────────────────────────────────────────────── -->
	<div class="sh-filter-bar">
		<mat-form-field appearance="outline" class="sh-field sh-field--order">
			<mat-label>Order number</mat-label>
			<input matInput [(ngModel)]="ordernoFilter" (keyup.enter)="applyFilters()" placeholder="Exact order #">
		</mat-form-field>
		<mat-form-field appearance="outline" class="sh-field sh-field--status">
			<mat-label>Invoice status</mat-label>
			<mat-select multiple [(ngModel)]="invoiceStatusFilters">
				<mat-option *ngFor="let o of invoiceStatusOptions" [value]="o.value">{{ o.label }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="sh-field sh-field--status">
			<mat-label>ERP order status</mat-label>
			<mat-select multiple [(ngModel)]="erpStatusFilters">
				<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="sh-field sh-field--date">
			<mat-label>Ship from</mat-label>
			<input matInput [matDatepicker]="filterFromPicker" [(ngModel)]="filterDateStart" [max]="filterDateEnd">
			<mat-datepicker-toggle matSuffix [for]="filterFromPicker"></mat-datepicker-toggle>
			<mat-datepicker #filterFromPicker></mat-datepicker>
		</mat-form-field>
		<span class="sh-date-sep">–</span>
		<mat-form-field appearance="outline" class="sh-field sh-field--date">
			<mat-label>Ship to</mat-label>
			<input matInput [matDatepicker]="filterToPicker" [(ngModel)]="filterDateEnd" [min]="filterDateStart">
			<mat-datepicker-toggle matSuffix [for]="filterToPicker"></mat-datepicker-toggle>
			<mat-datepicker #filterToPicker></mat-datepicker>
		</mat-form-field>
		<button mat-flat-button color="primary" (click)="applyFilters()" [disabled]="loading">
			<mat-icon>filter_list</mat-icon> Apply
		</button>
		<button mat-stroked-button (click)="clearFilters()" [disabled]="loading">
			<mat-icon>clear_all</mat-icon> Clear
		</button>
		<div class="sh-filter-spacer"></div>
		<button mat-stroked-button (click)="loadShipments()" [disabled]="loading">
			<mat-icon>refresh</mat-icon> Refresh
		</button>
		<button mat-stroked-button (click)="openRawRequestResponse()" [disabled]="rawLoading">
			<mat-spinner *ngIf="rawLoading" diameter="16"></mat-spinner>
			<mat-icon *ngIf="!rawLoading">visibility</mat-icon> View raw
		</button>
	</div>

	<!-- ── Quick date filters ────────────────────────────────────────────── -->
	<div class="sh-quick-filters">
		<span class="sh-quick-label">Quick filters:</span>
		<button mat-button (click)="setQuickDateFilter(7)" [disabled]="loading">Last 7 days</button>
		<button mat-button (click)="setQuickDateFilter(14)" [disabled]="loading">Last 14 days</button>
		<button mat-button (click)="setQuickDateFilter(30)" [disabled]="loading">Last 30 days</button>
		<button mat-button (click)="setQuickDateFilter(90)" [disabled]="loading">Last 90 days</button>
	</div>

	<!-- ── Poll bar ─────────────────────────────────────────────────────── -->
	<div class="sh-poll-bar">
		<mat-form-field appearance="outline" class="sh-field sh-field--date">
			<mat-label>Poll from</mat-label>
			<input matInput [matDatepicker]="pollFromPicker" [(ngModel)]="pollDateStart" [max]="pollDateEnd">
			<mat-datepicker-toggle matSuffix [for]="pollFromPicker"></mat-datepicker-toggle>
			<mat-datepicker #pollFromPicker></mat-datepicker>
		</mat-form-field>
		<span class="sh-date-sep">–</span>
		<mat-form-field appearance="outline" class="sh-field sh-field--date">
			<mat-label>Poll to</mat-label>
			<input matInput [matDatepicker]="pollToPicker" [(ngModel)]="pollDateEnd" [min]="pollDateStart">
			<mat-datepicker-toggle matSuffix [for]="pollToPicker"></mat-datepicker-toggle>
			<mat-datepicker #pollToPicker></mat-datepicker>
		</mat-form-field>
		<button mat-flat-button color="accent" (click)="pollShipments()" [disabled]="loading">
			<mat-spinner *ngIf="loading" diameter="16"></mat-spinner>
			<mat-icon *ngIf="!loading">sync</mat-icon> Poll Shipments
		</button>
		<span *ngIf="autoInvoiceEnabled" class="sh-auto-invoice-warn"
			matTooltip="Auto-invoice on shipment is ON — polling will automatically invoice newly imported shipments. You will be asked to confirm before polling.">
			<mat-icon>warning</mat-icon> Auto-invoice ON
		</span>
		<ng-container *ngIf="showCheckOrderByNo">
			<div class="sh-poll-sep"></div>
			<mat-form-field appearance="outline" class="sh-field sh-field--order">
				<mat-label>Order number</mat-label>
				<input matInput [(ngModel)]="singleOrderToCheck" (keyup.enter)="checkSingleOrder()" placeholder="Poll PGS for one order">
			</mat-form-field>
			<mat-form-field appearance="outline" class="sh-field sh-field--channel">
				<mat-label>Channel</mat-label>
				<mat-select [(ngModel)]="checkOrderChannel">
					<mat-option value="both">Both</mat-option>
					<mat-option value="b2b">B2B only</mat-option>
					<mat-option value="b2c">B2C only</mat-option>
				</mat-select>
			</mat-form-field>
			<button mat-flat-button color="primary" (click)="checkSingleOrder()" [disabled]="checkOrderLoading || !singleOrderToCheck?.trim()">
				<mat-spinner *ngIf="checkOrderLoading" diameter="16"></mat-spinner>
				<mat-icon *ngIf="!checkOrderLoading">manage_search</mat-icon> Fetch from PGS
			</button>
		</ng-container>
	</div>

	<div class="sh-poll-status" *ngIf="pollStatusMessage">
		<mat-spinner diameter="18"></mat-spinner>
		<span>{{ pollStatusMessage }}</span>
	</div>

	<div class="sh-help-banner">
		<mat-icon>info</mat-icon>
		<span><strong>Actions (⋮):</strong> opens the full action list. Disabled items do not apply to the row. <strong>Last Auth</strong> = latest card auth amount &amp; status (C = captured in ERP). <strong>ERP Gap</strong> = some auth on the order is marked captured (C) but neither a <code>capture</code> row nor a matching <code>cc_transactions</code> row exists (having either clears the gap). Use <em>Record ERP Capture</em> to backfill when both are missing (does not call Stripe). Open (uncaptured) holds are excluded from that reconcile rule; Last Auth can still show OPEN while an older captured row triggers ERP Gap.</span>
	</div>

	<!-- ── Bulk actions ──────────────────────────────────────────────────── -->
	<div class="sh-bulk-bar" *ngIf="selectedCount > 0 || bulkActionInProgress">
		<span class="sh-bulk-count" *ngIf="!bulkActionInProgress">{{ selectedCount }} selected</span>
		<div class="sh-bulk-progress" *ngIf="bulkActionInProgress">
			<mat-spinner diameter="22"></mat-spinner>
			<span class="sh-bulk-progress-text">{{ bulkActionStatusText }}</span>
		</div>
		<button mat-flat-button color="primary" (click)="bulkApprove()" [disabled]="!canBulkApprove">
			<mat-spinner *ngIf="bulkActionMode === 'approve'" diameter="18" class="sh-btn-spinner"></mat-spinner>
			<mat-icon *ngIf="bulkActionMode !== 'approve'">check</mat-icon>
			Bulk approve
		</button>
		<button mat-stroked-button color="accent" (click)="bulkApproveAndInvoice()" [disabled]="!canBulkApprove">
			<mat-spinner *ngIf="bulkActionMode === 'invoice'" diameter="18" class="sh-btn-spinner"></mat-spinner>
			<mat-icon *ngIf="bulkActionMode !== 'invoice'">receipt_long</mat-icon>
			Bulk approve &amp; invoice
		</button>
	</div>

	<!-- ── Table ─────────────────────────────────────────────────────────── -->
	<div class="sh-table-wrap position-relative">
		<div *ngIf="tableBusy" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p *ngIf="bulkActionInProgress && bulkActionStatusText" class="sh-bulk-overlay-msg">{{ bulkActionStatusText }}</p>
		</div>
		<table class="sh-table" [class.tpl3pl-loading-opacity]="tableBusy">
			<thead>
				<tr>
					<th class="sh-col-check">
						<mat-checkbox
							[checked]="isAllPendingSelected()"
							[indeterminate]="isBulkSelectionIndeterminate()"
							[disabled]="bulkEligibleOnPage.length === 0"
							(change)="toggleSelectAllPending($event.checked)"
							matTooltip="Select every actionable row on this page (pending, approved, or failed). Invoiced / on hold / rejected rows are skipped.">
						</mat-checkbox>
					</th>
					<th class="sh-col-order">Order</th>
					<th class="sh-col-debtor">Debtor #</th>
					<th class="sh-col-name">Name</th>
					<th class="sh-col-terms">Terms</th>
					<th class="sh-col-tracking">Tracking</th>
					<th class="sh-col-carrier">Carrier</th>
					<th class="sh-col-date">Ship Date</th>
					<th class="sh-col-status">Invoice Status</th>
					<th class="sh-col-phase">Phase</th>
					<th class="sh-col-money">Invoice $</th>
					<th class="sh-col-money">Last Auth</th>
					<th class="sh-col-erp-gap" matTooltip="Captured (C) auth exists but neither capture nor cc_transactions has this transaction id. Either record is enough to clear the gap. Record ERP Capture backfills — does NOT call Stripe.">ERP Gap</th>
					<th class="sh-col-attempts">Att.</th>
					<th class="sh-col-error">Error</th>
					<th class="sh-col-actions">Actions</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let item of shipments">
					<tr [class.sh-row-failed]="resolveInvoiceStatus(item) === 'failed'"
						[class.sh-row-invoiced]="resolveInvoiceStatus(item) === 'invoiced'"
						[class.sh-row-hold]="resolveInvoiceStatus(item) === 'on_hold'"
						[class.sh-row-rejected]="resolveInvoiceStatus(item) === 'rejected'">
						<td class="sh-col-check">
							<mat-checkbox *ngIf="canSelectShipment(item)"
								[checked]="isSelected(item)"
								(change)="toggleSelect(item, $event.checked)"
								matTooltip="Include in bulk approve / bulk invoice">
							</mat-checkbox>
							<span *ngIf="!canSelectShipment(item)" class="sh-check-na" matTooltip="Not eligible for bulk actions">—</span>
						</td>
						<td class="sh-col-order">
							<a href="javascript:void(0)" (click)="viewOrder(item.orderno)" class="sh-order-link">{{ item.orderno }}</a>
						</td>
						<td class="sh-col-debtor" [matTooltip]="item.debtorno ? ('Open customer ' + item.debtorno) : ''">
							<a *ngIf="item.debtorno" [routerLink]="'/customers/view/' + item.debtorno" class="sh-debtor-link">{{ item.debtorno }}</a>
							<span *ngIf="!item.debtorno">—</span>
						</td>
						<td class="sh-col-name" [matTooltip]="item.customer_name || ''">{{ item.customer_name || '—' }}</td>
						<td class="sh-col-terms" [matTooltip]="item.payterms || ''">{{ item.payterms || '—' }}</td>
						<td class="sh-col-tracking" [matTooltip]="item.tracking_number || ''">{{ item.tracking_number || '—' }}</td>
						<td class="sh-col-carrier" [matTooltip]="item.carrier || ''">{{ item.carrier || '—' }}</td>
						<td class="sh-col-date">{{ item.ship_date | date:'shortDate' }}</td>
						<td class="sh-col-status">
							<span class="sh-badge" [ngClass]="invoiceStatusClass(resolveInvoiceStatus(item))">
								{{ invoiceStatusLabel(resolveInvoiceStatus(item)) }}
							</span>
						</td>
						<td class="sh-col-phase">
							<span class="sh-badge sh-phase-badge"
								[ngClass]="{
									'phase-pre-invoice': processedPhaseNorm(item) === 'pre_invoice',
									'phase-pending-review': processedPhaseNorm(item) === 'pending_review',
									'phase-auto-invoiced': processedPhaseNorm(item) === 'auto_invoiced',
									'phase-invoice-failed': processedPhaseNorm(item) === 'invoice_failed'
								}"
								[matTooltip]="item.invoice_message || phaseLabelFromItem(item)">
								{{ phaseLabelFromItem(item) }}
							</span>
						</td>
						<td class="sh-col-money sh-money">
							<ng-container *ngIf="item.invoice_total != null">
								<span [matTooltip]="item.invoice_transno ? 'Invoice #' + item.invoice_transno : ''">
									{{ item.invoice_total | currency:'USD':'symbol':'1.2-2' }}
								</span>
							</ng-container>
							<span *ngIf="item.invoice_total == null" class="text-muted">—</span>
						</td>
						<td class="sh-col-money sh-money sh-auth-cell">
							<ng-container *ngIf="item.last_auth_amount != null && item.last_auth_amount > 0">
								<div class="sh-auth-line"
									[class.sh-auth-mismatch]="item.invoice_total != null && item.last_auth_amount != null && (item.invoice_total - item.last_auth_amount) > 0.01"
									[matTooltip]="item.last_auth_transid || ''">
									<span class="sh-auth-amt">{{ item.last_auth_amount | currency:'USD':'symbol':'1.2-2' }}</span>
									<span class="sh-auth-stat">{{ lastAuthStatusLabel(item.last_auth_status) }}</span>
								</div>
							</ng-container>
							<span *ngIf="item.last_auth_amount == null || item.last_auth_amount === 0" class="text-muted">—</span>
						</td>
						<td class="sh-col-erp-gap">
							<ng-container *ngIf="item.reconcile_auth_id">
								<span class="sh-erp-gap-badge"
									matTooltip="Captured auth with no capture or cc_transactions row (either clears gap). Use Record ERP Capture in Actions (⋮). Does NOT call Stripe.">
									ERP Gap
								</span>
							</ng-container>
							<span *ngIf="!item.reconcile_auth_id" class="text-muted">—</span>
						</td>
						<td class="sh-col-attempts">{{ item.invoice_attempts || 0 }}</td>
						<td class="sh-col-error" [matTooltip]="item.invoice_message || ''">
							<span *ngIf="item.invoice_message" class="sh-error-text">{{ item.invoice_message }}</span>
							<span *ngIf="!item.invoice_message" class="text-muted">—</span>
						</td>
						<td class="sh-col-actions">
							<div class="sh-actions">
								<mat-spinner *ngIf="actionInProgressId === item.id" diameter="20"></mat-spinner>
								<ng-container *ngIf="actionInProgressId !== item.id">
									<button mat-icon-button color="accent" (click)="openInvoicePreview(item)" matTooltip="Invoice preview"><mat-icon>preview</mat-icon></button>
									<button mat-icon-button
										class="sh-actions-overflow"
										[matMenuTriggerFor]="shipmentActionsMenu"
										(click)="actionMenuShipment = item"
										matTooltip="All actions (mark invoiced, capture, approve, …)">
										<mat-icon>more_vert</mat-icon>
									</button>
									<button mat-icon-button (click)="toggleExpand(item)" [matTooltip]="expandedShipmentId === item.id ? 'Collapse raw JSON' : 'View raw JSON'">
										<mat-icon>{{ expandedShipmentId === item.id ? 'expand_less' : 'data_object' }}</mat-icon>
									</button>
								</ng-container>
							</div>
						</td>
					</tr>
					<tr *ngIf="expandedShipmentId === item.id" class="sh-raw-row">
						<td colspan="16">
							<pre class="sh-raw-pre">{{ item.raw_data | json }}</pre>
						</td>
					</tr>
				</ng-container>
				<tr *ngIf="!loading && shipments.length === 0">
					<td colspan="16" class="sh-empty">No shipments found for the current filters.</td>
				</tr>
			</tbody>
		</table>

		<mat-paginator
			*ngIf="shipmentsTotal > 0"
			[length]="shipmentsTotal"
			[pageSize]="pageSize"
			[pageIndex]="pageIndex"
			[pageSizeOptions]="pageSizeOptions"
			(page)="onPage($event)"
			showFirstLastButtons>
		</mat-paginator>
	</div>

	<!-- ── Poll result ───────────────────────────────────────────────────── -->
	<div *ngIf="lastPollResult" class="sh-poll-result mt-3"
		[ngClass]="{
			'sh-poll-ok': lastPollResult.success && lastPollResult.processed > 0,
			'sh-poll-none': lastPollResult.success && lastPollResult.processed === 0,
			'sh-poll-err': !lastPollResult.success
		}">
		<div class="sh-poll-result-body">
			<strong>{{ !lastPollResult.success ? 'Poll failed:' : (lastPollResult.processed > 0 ? 'Poll complete:' : 'No shipments:') }}</strong>
			{{ lastPollResult.message }}
			<span *ngIf="lastPollResult.success && lastPollResult.processed !== undefined"> ({{ lastPollResult.processed }} processed)</span>
		</div>
		<button type="button" class="sh-poll-close" (click)="lastPollResult = null" aria-label="Close">×</button>
	</div>
	<div *ngIf="!lastPollResult?.success && lastPollResult?.response" class="mt-2">
		<details>
			<summary class="sh-details-summary">API response</summary>
			<pre class="sh-raw-pre mt-1">{{ lastPollResult.response | json }}</pre>
		</details>
	</div>

<mat-menu #shipmentActionsMenu="matMenu" class="sh-actions-menu">
	<button mat-menu-item (click)="runMenuPreview()">
		<mat-icon>preview</mat-icon>
		<span>Invoice preview</span>
	</button>
	<mat-divider></mat-divider>
	<button mat-menu-item (click)="runMenuMarkInvoiced()" [disabled]="!menuCanMarkInvoiced()">
		<mat-icon class="sh-menu-ic-mark-invoiced">task_alt</mat-icon>
		<span>Mark row invoiced (sync queue)</span>
	</button>
	<button mat-menu-item (click)="runMenuMarkCaptured()" [disabled]="!menuCanMarkCaptured()">
		<mat-icon class="sh-menu-ic-capture">price_check</mat-icon>
		<span>Record ERP capture / card txn</span>
	</button>
	<mat-divider></mat-divider>
	<button mat-menu-item (click)="runMenuApprove()" [disabled]="!menuCanApprove()">
		<mat-icon>check_circle</mat-icon>
		<span>Approve</span>
	</button>
	<button mat-menu-item (click)="runMenuApproveAndInvoice()" [disabled]="!menuCanApproveAndInvoice()">
		<mat-icon>receipt_long</mat-icon>
		<span>Approve &amp; invoice</span>
	</button>
	<button mat-menu-item (click)="runMenuRetryInvoice()" [disabled]="!menuCanRetryInvoice()">
		<mat-icon>refresh</mat-icon>
		<span>Retry invoice</span>
	</button>
	<mat-divider></mat-divider>
	<button mat-menu-item (click)="runMenuHold()" [disabled]="!menuCanHold()">
		<mat-icon>pause_circle</mat-icon>
		<span>Put on hold</span>
	</button>
	<button mat-menu-item (click)="runMenuReleaseHold()" [disabled]="!menuCanReleaseHold()">
		<mat-icon>play_circle</mat-icon>
		<span>Release hold</span>
	</button>
	<button mat-menu-item (click)="runMenuReject()" [disabled]="!menuCanReject()">
		<mat-icon>cancel</mat-icon>
		<span>Reject</span>
	</button>
</mat-menu>

</div>
